import { Global } from '../Global';
import { postTianai } from '../utils/TianaiApiUtil';
import {
  CaptchaChallengeDTO,
  CaptchaCheckParamDTO,
} from '../components/TianaiCaptchaModal/CaptchaType';

const mockChallenge = (): CaptchaChallengeDTO => ({
  id: 'mock-captcha',
  backgroundImage: '',
  templateImage: '',
  backgroundImageWidth: 300,
  backgroundImageHeight: 180,
  templateImageWidth: 60,
  templateImageHeight: 180,
});

const genCaptcha = async (): Promise<CaptchaChallengeDTO | null> => {
  if (Global.isMockMode()) {
    return mockChallenge();
  }
  const data = await postTianai<CaptchaChallengeDTO>('/mix/genCaptcha', {});
  if (!data?.id || !data.backgroundImage) {
    return null;
  }
  return data;
};

const checkCaptcha = async (
  param: CaptchaCheckParamDTO,
): Promise<string | null> => {
  if (Global.isMockMode()) {
    return 'mock-captcha-token';
  }
  const data = await postTianai<{ token?: string }>('/mix/check', param);
  const token = data?.token;
  return token && token.length > 0 ? token : null;
};

export const CaptchaApi = {
  genCaptcha,
  checkCaptcha,
};
